module.exports = __webpack_public_path__ + "img/chartOneBackground.268395b4.png";